import type { ReactNode } from 'react';
import { AppIcon, useGlow } from '@hana/ui';
import s from './Login.module.css';

/** Nền chấm + đường tuyến + hiệu ứng sáng của trang đăng nhập (board Mint-Hub). */
export function AuthShell({ top, children }: { top: ReactNode; children: ReactNode }) {
  const glow = useGlow();
  return (
    <div className={`${s.root} hana-glow-root`} onPointerMove={glow.onPointerMove}>
      <svg className={s.deco} aria-hidden="true" preserveAspectRatio="xMidYMid slice" viewBox="0 0 1536 980">
        <defs>
          <pattern id="hbDots" width="24" height="24" patternUnits="userSpaceOnUse">
            <circle cx="2" cy="2" r="1.1" className={s.dot} />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#hbDots)" />
        <path className={s.route} d="M120 820 C 380 700, 520 880, 760 760 S 1180 480, 1420 360" />
      </svg>
      {glow.layer}
      <header className={s.top}>
        <AppIcon app="hub" size={32} />
        <b className={s.brand}>HANA Hub</b>
        {top}
      </header>
      {children}
    </div>
  );
}
